import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { I18nContext } from '../../I18n'
import VideoPlayer from '../../Common/VideoPlayer'

const UniversalVideo = ({ video = [] }) => {
  const I18n = useContext(I18nContext)

  // Нормализация данных для поддержки старого и нового форматов
  const normalizedVideos = video.map(v => {
    // Если есть готовый video_html - используем его
    if (v.video_html) return v
    
    // Для старых данных с youtube_id
    if (v.youtube_id) {
      return {
        ...v,
        video_html: `<iframe src="https://www.youtube.com/embed/${v.youtube_id}?autoplay=1" frameborder="0" allowfullscreen></iframe>`
      }
    }
    
    return null
  }).filter(Boolean)

  if (!normalizedVideos.length) return null

  return (
    <div className="video-section">
      <div className="section-heading">
        {I18n.t('pages.index.youtube.title')}
      </div>

      {normalizedVideos.map(v => (
        <div key={v.id} style={{ marginBottom: '2rem' }}>
          <VideoPlayer html={v.video_html} />
          {v.title && <h3 style={{ marginTop: '0.5rem' }}>{v.title}</h3>}
          {v.created && (
            <p style={{ color: '#666', fontSize: '0.9rem' }}>
              {dayjs.unix(v.created).locale(I18n.locale).format('D MMMM YYYY')}
            </p>
          )}
        </div>
      ))}
    </div>
  )
}

UniversalVideo.propTypes = {
  video: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      video_html: PropTypes.string,
      youtube_id: PropTypes.string, // для старых данных
      title: PropTypes.string,
      created: PropTypes.number
    })
  )
}

export default UniversalVideo